import {Grid, Box, Paper, Typography, Alert} from '@mui/material'
import { DeviceTypeSelector } from './Controls/DeviceTypeSelector'
import { LogViewer } from './Controls/LogViewer'
import { BurnInLogs } from './Controls/BurnInLogs'
import { ServerLogs } from './Controls/ServerLogs'
import { Dashboard } from './Controls/Dashboard'
import { Header } from './Header/Header'
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import * as React from "react";
import {useContext} from "react";
import {IDPoolContext} from "./Context/IDContext";


const identityServer =  process.env.NODE_ENV==="development" ?  "http://127.0.0.1:8000" : ""


export default function Layout() {
    const [value, setValue] = React.useState('1');
    const {loading,
        error,accessToken } = useContext(IDPoolContext)
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };
    return(

        <div>
            <Header/>
            {loading && <Alert severity="info">Waiting for Server</Alert>}
            {!loading && error && <Alert severity="error">{error}</Alert>}
            {!error &&
                <div>
                    <Grid container spacing={2} p={3}>
                        <Grid item xs={12}>
                            <DeviceTypeSelector/>
                        </Grid>
                    </Grid>
                    <TabContext value={value}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={handleChange} aria-label="Log Tabs">
                                <Tab label="Dashboard" value="1" />
                                <Tab label="Provisioning Logs" value="2" />
                                <Tab label="Burn In Log" value="3" />
                                <Tab label="Server Log" value="4" />
                            </TabList>
                        </Box>
                        <TabPanel value="1">{loading?<Typography variant="h2"  align="center">Loading</Typography>:<Dashboard />}</TabPanel>
                        <TabPanel value="2">{loading?<Typography variant="h2"  align="center">Loading</Typography>:<LogViewer />}</TabPanel>
                        <TabPanel value="3">{loading?<Typography variant="h2"  align="center">Loading</Typography>:<BurnInLogs />}</TabPanel>
                        <TabPanel value="4">{loading?<Typography variant="h2"  align="center">Loading</Typography>:<ServerLogs />}</TabPanel>
                    </TabContext>
                </div>
            }
        </div>
        )

}
